<template>
  <b-modal v-if="modalData" class="modal-lg" size="lg" id="modalEmailInfo" ref="delete-modal" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" hide-footer @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'envelope']" class="mr-2"/> {{ t('deliveryReportsEmailDetailsTitle', 'deliveryReportsEmailDetailsTitle') }} </h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div v-if="modalData.message" class="col-12">
        <div v-if="modalData.isSerialized">
          <div v-if="modalData.message.state == 'soft-bounced'" class="col-12">
            <h4>{{ t('deliveryReportsSoftBounced', 'deliveryReportsSoftBounced') }}</h4>
            <p>
              {{ t('deliveryReportsReasonLabel', 'deliveryReportsReasonLabel') }} : {{ modalData.message.diag }} <br><br>
              <small>{{ t('deliveryReportsTypeLabel', 'deliveryReportsTypeLabel') }} : {{ modalData.message.bounce_description }}</small>
            </p>
          </div>
          <div v-if="modalData.message.state == 'bounced'" class="col-12">
            <h4>{{ t('deliveryReportsHardBounced', 'deliveryReportsHardBounced') }}</h4>
            <p>
              {{ t('deliveryReportsReasonLabel', 'deliveryReportsReasonLabel') }} : {{ modalData.message.diag }} <br><br>
              <small>{{ t('deliveryReportsTypeLabel', 'deliveryReportsTypeLabel') }} : {{ modalData.message.bounce_description }}</small>
            </p>
          </div>
          <div v-if="modalData.message.smtp_events && modalData.message.smtp_events.length > 0" class="col-12" style="overflow-x: auto">
            <h4>{{ t('deliveryReportsEmailSmtpEvents', 'deliveryReportsEmailSmtpEvents') }}</h4>
            <b-table style="max-width: 100% !important;" striped hover :fields="deferred_fields" :items="modalData.message.smtp_events">
              <template v-slot:head(ts)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(type)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(diag)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:cell(ts)="data">
                {{ data.item.ts | timestampToDate }}
              </template>
            </b-table>
          </div>
          <div v-if="modalData.message.opens && modalData.message.opens.length > 0" class="col-12" style="overflow-x: auto">
            <h4>{{ t('deliveryReportsOpensLabel', 'deliveryReportsOpensLabel') }}</h4>
            <b-table style="max-width: 100% !important;" striped hover :fields="opens_fields" :items="modalData.message.opens">
              <template v-slot:head(ts)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(ip)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(location)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(ua)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:cell(ts)="data">
                {{ data.item.ts | timestampToDate }}
              </template>
              <template v-slot:cell(location)="data">
                <span v-if="data.item.location">
                  {{ data.item.location }}
                </span>
                <span v-else>
                   {{ t('deliveryReportNotAvailableLabel', 'deliveryReportNotAvailableLabel') }}
                </span>
              </template>
              <template v-slot:cell(ua)="data">
                <span v-if="data.item.ua">
                  {{ data.item.ua }}
                </span>
                <span v-else>
                  {{ t('deliveryReportNotAvailableLabel', 'deliveryReportNotAvailableLabel') }}
                </span>
              </template>
            </b-table>
          </div>
          <div v-if="modalData.message.clicks && modalData.message.clicks.length > 0" :fields="clicks_fields" :items="modalData.message.clicks" class="col-12" style="overflow-x: auto">
            <h4>{{ t('deliveryReportsClicksLabel', 'deliveryReportsClicksLabel') }}</h4>
            <b-table style="max-width: 100% !important;" responsive striped hover :fields="clicks_fields" :items="modalData.message.clicks">
              <template v-slot:head(ts)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(ip)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(location)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(ua)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(url)="data">
                <span >{{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:cell(ts)="data">
                {{ data.item.ts | timestampToDate }}
              </template>
              <template v-slot:cell(location)="data">
                <span v-if="data.item.location">
                  {{ data.item.location }}
                </span>
                <span v-else>
                  N / A
                </span>
              </template>
              <template v-slot:cell(ua)="data">
                <span v-if="data.item.ua">
                  {{ data.item.ua }}
                </span>
                <span v-else>
                  N / A
                </span>
              </template>
            </b-table>
          </div>
          <!--ALL-9707 default message added to avoid empty modal being shown RR -->
          <div v-if="showDefaultMessage">
            <h4 class="text-center">{{ t('deliveryReportsEmailInfoLabel', 'deliveryReportsEmailInfoLabel') }}</h4>
            <template v-if="modalData.message.email">
              <p><strong>{{ t('emailRecipient', 'emailRecipient') }}: </strong>{{modalData.message.email}}</p>
            </template>
            <template v-if="modalData.message.sender">
              <p><strong>{{ t('emailSender', 'emailSender') }}: </strong>{{modalData.message.sender}}</p>
            </template>
            <template v-if="modalData.message.subject">
              <p><strong>{{ t('emailSubject', 'emailSubject') }}: </strong>{{modalData.message.subject}}</p>
            </template>
            <p>{{t('noMoreDetailsFoundAboutTheEmailState', 'noMoreDetailsFoundAboutTheEmailState')}}</p>
          </div>
        </div>
        <div v-else class="col-12">
          <p>{{ modalData.message }}</p>
        </div>
        <!-- ALL-10079 asked for a rollback -->
        <!--<div class="col-12 mt-2">
          <p>{{ t('deliveryReportsExtraDetails', 'deliveryReportsExtraDetails') }}: <router-link :to="{ path: '/faq' }">{{ t('faqTitle', 'faqTitle') }}</router-link></p>
        </div>-->
      </div>
      <div v-else class="col-12">
        {{ t('noEmailSendDetailsFound', 'noEmailSendDetailsFound') }}
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ModelEmailInfo',
  data () {
    return {
      opens_fields: [
        { key: 'ts', label: 'deliveryReportsTimestampHeader', thClass: 'hover-pointer brand-color' },
        { key: 'ip', label: 'deliveryReportsIpHeader', thClass: 'hover-pointer brand-color' },
        { key: 'location', label: 'deliveryReportsLocaltionHeader', thClass: 'hover-pointer brand-color' },
        { key: 'ua', label: 'deliveryReportsBrowserHeader', thClass: 'hover-pointer brand-color' }
      ],
      clicks_fields: [
        { key: 'ts', label: 'deliveryReportsTimestampHeader', thClass: 'hover-pointer brand-color' },
        { key: 'ip', label: 'deliveryReportsIpHeader', thClass: 'hover-pointer brand-color' },
        { key: 'location', label: 'deliveryReportsLocaltionHeader', thClass: 'hover-pointer brand-color' },
        { key: 'ua', label: 'deliveryReportsBrowserHeader', thClass: 'hover-pointer brand-color' },
        { key: 'url', label: 'deliveryReportsUrlHeader', thClass: 'hover-pointer brand-color' }
      ],
      deferred_fields: [
        { key: 'ts', label: 'deliveryReportsTimestampHeader', thClass: 'hover-pointer brand-color' },
        { key: 'type', label: 'deliveryReportsTypeHeader', thClass: 'hover-pointer brand-color' },
        { key: 'diag', label: 'deliveryReportsDiagHeader', thClass: 'hover-pointer brand-color' }
      ]
    }
  },
  methods: {
    closeModal() {
      if(this.modalData.sendId && this.modalData.message && Object.keys(this.modalData.message).length > 0) {
        if(this.modalData.message.state == 'delivered' || this.modalData.message.state == 'sent') {
          this.$parent.updateSendStatusText(this.modalData.sendId)
        }
      }
      this.$parent.modalData = {}
    }
  },
  computed: {
    modalData() {
      return this.$attrs.modalData
    },
    //ALL-9707 computed variable added to determine if we need to show the default message RR
    showDefaultMessage() {
      let message = this.modalData.message
      //we will determine if we want to show the default message inside the modal
      //with this variable
      let showDefault = false
      //we have 5 cases for different messages to show inside the modal
      //so we count how many messages we skipped to see if we need to show
      //the default message
      let skippedMessages = 0

      if(message.state != 'soft-bounced') {
        skippedMessages++
      }

      if(message.state != 'bounced') {
        skippedMessages++
      }

      if((message.state != 'deferred') || ((message.state == 'deferred') && ((!message.smtp_events) || (message.smtp_events.length < 1)))) {
        skippedMessages++
      }

      if((!message.opens) || message.opens.length < 1) {
        skippedMessages++
      }

      if((!message.clicks) || message.clicks.length < 1) {
        skippedMessages++
      }

      if(skippedMessages == 5) {
        showDefault = true
      }

      return showDefault
    }
  },
  filters: {
    timestampToDate(timestamp) {
      return moment.unix(timestamp).format('LLLL')
    }
  }
}
</script>

<style scoped>
  .button-h {
    max-height: 30px;
  }
  .table  >>> .brand-color, .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table >>> .hover-pointer:hover, .table-responsive >>> .hover-pointer:hover {
    cursor: pointer !important;
  }
</style>
